import styled, { css } from 'styled-components';

export const FeatureVideoSummaryWrapper = styled.div`
  padding-bottom: 56px;

  [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
    a {
      display: flex;
      justify-content: space-between;
      @media only screen and (max-width: 1000px) {
        flex-direction: column-reverse;
        justify-content: flex-end;
        height: auto;
        max-height: initial;
        min-height: initial;
      }
    }
  }
`;

export const TextBlockWrapper = styled.div`
  padding: 20px 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  width: calc(100% / 3);
  min-width: 390px;

  @media only screen and (max-width: 1000px) {
    padding: 20px;
    width: 100%;
    min-width: 0;
  }
  > p {
    margin: 10px 0 0 0;
  }
`;

export const VideoBlockWrapper = styled.div`
  width: 100%;
  object-fit: cover;
  object-position: 50% 50%;
  width: calc(100% / 3 * 2);
  @media only screen and (max-width: 1000px) {
    height: 424px;
    width: 100%;
  }
  @media only screen and (max-width: 700px) {
    min-height: 350px;
  }
  @media only screen and (max-width: 400px) {
    min-height: 301px;
  }
`;

export const VideoContainerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const videoiframe = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const bgWhite = css`
  background: var(--white);
`;

export const bgAbbey = css`
  background: var(--gallery);
`;